'use strict';
import {getCollection, getDomainClass, getId} from '../../core-utilities/domain/ReduxUtils';
import {getOrganization} from '../../app/model/reducers/state';


module.exports = [
  '$modal',
  '$scope',
  '$ngRedux',
  'PersonDomain',
  'PersonnelFilterMixin',
  'currentValue',
  'currentFilter',
  'nullLabel',
  'exclusions',
  'target',
  PrivatePersonnelSelectController];

function PrivatePersonnelSelectController(
  $modal,
  $scope,
  $ngRedux,
  PersonDomain,
  PersonnelFilterMixin,
  currentValue,
  currentFilter,
  nullLabel,
  exclusions,
  target,
) {
  const vm = $scope.selector = {
    onSelect: onSelect,
    cancel: cancel,
    currentValue: currentValue,
    currentFilter: currentFilter,
    nullable: nullLabel || 'Unassigned', // TODO(i18n): improve fallback and convert to handle i18n
    exclusions: exclusions,
    showNonUsers: false,

    organization: getOrganization($ngRedux.getState())
  };

  const filter = PersonnelFilterMixin($scope, $scope, vm);

  loadPersons();
  loadTeams();

  function onSelect(result) {
    document.getElementById("search-filter").blur();
    $modal.hide(result);
  }

  function cancel() {
    document.getElementById("search-filter").blur();
    $modal.cancel();
  }

  function loadPersons() {
    const domainClass = getDomainClass(getCollection(target));
    const members$ = domainClass.$getMembersRelations(getId(target))
      .$toObservable()
      .switchMap(retrievePersons);

    filter.initFiltering(members$);
  }

  function retrievePersons(members) {
    const list = [];
    for (let userId in members) {
      if (members.hasOwnProperty(userId) && members[userId].aliasId) {
        list.push(PersonDomain.$get(members[userId].aliasId));
      }
    }

    return Promise.all(list);
  }

  function loadTeams() {
    const domainClass = getDomainClass(getCollection(target));
    vm.teams = domainClass.$getMembersTeamsList(getId(target));
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/selectors/PrivatePersonnelSelectController.js